__turbopack_context__.v({
  "badge": "styles-module__8dQKya__badge",
  "badgeIcon": "styles-module__8dQKya__badgeIcon",
  "collageImageDesktop": "styles-module__8dQKya__collageImageDesktop",
  "collageImageMobile": "styles-module__8dQKya__collageImageMobile",
  "content": "styles-module__8dQKya__content",
  "description": "styles-module__8dQKya__description",
  "heading": "styles-module__8dQKya__heading",
  "hero": "styles-module__8dQKya__hero",
  "imageCollage": "styles-module__8dQKya__imageCollage",
  "layout": "styles-module__8dQKya__layout",
});
